// src/services/HistorialService.js
import API from "./Config";

const ENDPOINT = "/paciente/me/historial/paciente";

const HistorialService = {
  /** Devuelve un array con todos los registros históricos del paciente logueado */
  fetchHistorial: () =>
    API.get(ENDPOINT).then((res) => res.data),
};

export default HistorialService;